import { RadioGroup } from '@zoopla-eng/zds-components/radio-group';
import { FilterWrapper } from './SearchInitiationMobile.styles';

const propertyTypes = ['property', 'houses', 'flats', 'farms_land'] as const;

export type PropertyType = typeof propertyTypes[number];

type SelectNewHomesDevelopersPropertyTypeProps = {
    value: PropertyType;
    onChange: (propertyType: PropertyType) => void;
};

export const SelectNewHomesDevelopersPropertyType = ({
    value,
    onChange
}: SelectNewHomesDevelopersPropertyTypeProps) => {
    const propertyTypeLabel = 'Property type';

    return (
        <FilterWrapper>
            <label htmlFor="modal-property-type-filter">
                {propertyTypeLabel}
            </label>
            <RadioGroup
                label=""
                bisect={true}
                value={value}
                items={[
                    {
                        id: 'show_all',
                        value: 'property',
                        label: 'Show all'
                    },
                    {
                        id: 'houses',
                        value: 'houses',
                        label: 'Houses'
                    },
                    {
                        id: 'flats',
                        value: 'flats',
                        label: 'Flats'
                    }
                ]}
                onValueChange={onChange}
            />{' '}
        </FilterWrapper>
    );
};
